import { useEffect, useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import "./Navbar.css";

function Navbar() {
  const { user, role, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);

  // Lock body scroll when sidebar is open
  useEffect(() => {
    document.body.style.overflow = menuOpen ? "hidden" : "";
    return () => { document.body.style.overflow = ""; };
  }, [menuOpen]);

  // Close sidebar + dropdown on route change
  useEffect(() => {
    setMenuOpen(false);
    setDropdownOpen(false);
  }, [location.pathname]);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
  };

  // Close dropdown on outside click
  useEffect(() => {
    if (!dropdownOpen) return;
    const handler = () => setDropdownOpen(false);
    document.addEventListener("click", handler);
    return () => document.removeEventListener("click", handler);
  }, [dropdownOpen]);

  const handleLogout = async () => {
    await logout();
    navigate("/");
  };

  return (
    <>
      <nav className="site-navbar">
        <div className="navbar-inner">
          <Link className="site-navbar-brand" to="/" onClick={scrollToTop}>Al-Yasin</Link>

          {/* Desktop links */}
          <div className="nav-desktop">
            <Link className="site-nav-link" to="/" onClick={scrollToTop}>Hjem</Link>
            <Link className="site-nav-link" to="/om-oss">Om oss</Link>
            <Link className="site-nav-link" to="/konsultasjoner">Undervisning</Link>
            <Link className="site-nav-link" to="/seminarer">Seminarer</Link>
            {user ? (
              <>
                {role === "admin" && (
                  <Link className="site-nav-link" to="/admin">Admin</Link>
                )}
                <span className="site-nav-link-gold">
                  Hei, {user} {role === "member" ? "👤" : "⚙️"}
                </span>
                <button className="nav-btn" onClick={handleLogout}>Logg ut</button>
              </>
            ) : (
              <div className="nav-dropdown">
                <span
                  className="nav-dropdown-toggle"
                  onClick={(e) => { e.stopPropagation(); setDropdownOpen(o => !o); }}
                >
                  Min side
                </span>
                {dropdownOpen && (
                  <div className="nav-dropdown-menu">
                    <Link className="nav-dropdown-item" to="/login">Logg inn</Link>
                    <Link className="nav-dropdown-item" to="/signup">Bli medlem</Link>
                  </div>
                )}
              </div>
            )}
          </div>

          {/* Hamburger */}
          <button
            className="hamburger"
            onClick={() => setMenuOpen(true)}
            aria-label="Åpne meny"
          >
            <span /><span /><span />
          </button>
        </div>
      </nav>

      {/* Backdrop */}
      <div
        className={`sidebar-backdrop${menuOpen ? " open" : ""}`}
        onClick={() => setMenuOpen(false)}
      />

      {/* Sidebar */}
      <div className={`sidebar${menuOpen ? " open" : ""}`}>
        <div className="sidebar-header">
          <Link className="sidebar-title" to="/" onClick={() => { setMenuOpen(false); scrollToTop(); }}>Al-Yasin</Link>
          <button className="sidebar-close" onClick={() => setMenuOpen(false)}>✕</button>
        </div>
        <div className="sidebar-body">
          <Link className="sidebar-link" to="/" onClick={() => { setMenuOpen(false); scrollToTop(); }}>Hjem</Link>
          <Link className="sidebar-link" to="/om-oss" onClick={() => setMenuOpen(false)}>Om oss</Link>
          <Link className="sidebar-link" to="/konsultasjoner" onClick={() => setMenuOpen(false)}>Undervisning</Link>
          <Link className="sidebar-link" to="/seminarer" onClick={() => setMenuOpen(false)}>Seminarer</Link>
          {user ? (
            <>
              {role === "admin" && (
                <Link className="sidebar-link" to="/admin" onClick={() => setMenuOpen(false)}>Admin</Link>
              )}
              <span className="sidebar-gold">
                Hei, {user} {role === "member" ? "👤" : "⚙️"}
              </span>
              <button className="sidebar-btn" onClick={handleLogout}>Logg ut</button>
            </>
          ) : (
            <>
              <Link className="sidebar-link" to="/login" onClick={() => setMenuOpen(false)}>Logg inn</Link>
              <Link className="sidebar-link" to="/signup" onClick={() => setMenuOpen(false)}>Bli medlem</Link>
            </>
          )}
        </div>
      </div>
    </>
  );
}

export default Navbar;
